import type { TablePaginationConfig } from './Table.types';

import { cn } from 'utils/cn';

import ArrowIcon from 'components/Icons/ArrowIcon';

const TablePagination = ({
  totalResults,
  resultsPerPage,
  currentPage,
  setCurrentPage
}: TablePaginationConfig) => {
  const totalPages = Math.ceil((totalResults || 0) / resultsPerPage);

  return (
    <div className='relative z-11 mt-0.5 flex flex-col items-center justify-center rounded-t-lg bg-blue-900'>
      <button
        onClick={() => setCurrentPage(currentPage - 1)}
        className={cn(
          'absolute -bottom-3.5 left-5.25 rounded-full bg-transparent p-2 transition-colors duration-300',
          'group size-7',
          'hover:bg-blue-200/10',
          'disabled:bg-transparent'
        )}
        disabled={currentPage === 1 || !totalResults}
      >
        <ArrowIcon className='rotate-180 fill-blue-200 group-disabled:fill-gray-800' />
      </button>

      <span className='py-2.5 text-xs text-gray-800'>
        Page {currentPage} of {totalPages || 1}
      </span>

      <button
        onClick={() => setCurrentPage(currentPage + 1)}
        className={cn(
          'absolute -bottom-3.5 right-5.25 rounded-full bg-transparent p-2 transition-colors duration-300',
          'group size-7',
          'hover:bg-blue-200/10',
          'disabled:bg-transparent'
        )}
        disabled={currentPage >= totalPages || !totalResults}
      >
        <ArrowIcon className='fill-blue-200 group-disabled:fill-gray-800' />
      </button>
    </div>
  );
};

export default TablePagination;
